import { SuggestedProducts } from '@/types/search'
import AlgoliaSearch from '@/scripts/libs/algolia/search'
import { SEARCH_TERM_QUERY_PARAM } from '@/scripts/constants/search'

export interface SearchService {
  fetchSuggestedProducts(_: string): Promise<SuggestedProducts>
}

class Search implements SearchService {
  fetchSuggestedProducts = async (searchValue: string): Promise<SuggestedProducts> => {
    return AlgoliaSearch.fetchSuggestedProducts(searchValue)
  }

  getSearchTermQueryParam = () => {
    const queryParams = new URLSearchParams(window.location.search)

    const searchTermQueryParam = queryParams.get(SEARCH_TERM_QUERY_PARAM)
    return searchTermQueryParam
  }
}

export default new Search()
